module.exports = __webpack_public_path__ + "img/ji2.9f348797.png";